export default class EventLinks {

	static getHolderSelectors = () => ['.event-links'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		this.#logoHover();
	}

	#logoHover() {
		const logoHover = this.#holderElement.querySelector('.logo-hover');
		const gradientHover = logoHover.querySelector('.gradient-hover');
		let updatePosition = true;

		logoHover.addEventListener('mousemove', event => {
			if (updatePosition) {
				updatePosition = false;
				gradientHover.style.background = `radial-gradient(circle at ${event.offsetX}px ${event.offsetY}px, rgba(0,0,0,0) 0%, rgba(0,0,0,.98) 400px)`;
				window.setTimeout(() => updatePosition = true, 50);
			}
		});
	}

}
